import { Col, Row, Button } from "react-bootstrap";
import { Box } from "../../../components/box";
import FontFa from "../../../components/fontFa/fontFa";
import { Column, ColumnFixing, DataGrid, Export, FilterRow, HeaderFilter, Scrolling } from "devextreme-react/data-grid";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { withStatisticWapper } from "../statistics";
import { StatisticChart } from "../chart";
import LinkDocumentModal from "../../document/modal/link-document-modal";
import { getListIdByStatusValue } from "../../../services/serviceHelper";
import { DocumentService } from "../../../services/document/document.service";
import { UserDepartmentModal } from "../modal/user-department-modal";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import saveAs from "file-saver";
import { useSearchParams } from "../../../hook/use-search-params";
import { isGUID } from "../../document/util";
import { CreateNotification } from "../../../components/notifier";
import { useSelector } from "../../../store/store";
import { getEnv } from "../../../AppConfigs";
import { mailRegexs } from "../../../constants/mailTemplateConstants";
import { MailService } from "../../../services/mail/mail.service";
import moment from "moment";
import { DateFormat } from "../../../constants";
import { useUser } from "../../../hook";
import { useNonEmailUsers } from "../../document/hooks/published-documents/use-non-email-users";
import { RecentDistributionDocument } from "./recent-distribution-document";
import { StringHelper } from "../../../helper";

const positionFilters = ["-TP", "-PP", "-TTT", "-PTT"];

const isCBP = (jobTitle?: string): boolean => {
  if (!jobTitle) return false;
  return jobTitle.split("-").some((s) => positionFilters.includes(s));
};

export const StatisticDistributionDocumentPage = withStatisticWapper(() => {
  const [document, setDocument] = useState<any>(null);
  const [openLinkDocumentModal, setOpenLinkDocumentModalModal] = useState(false);
  const [openUserDepartmentModal, setOpenUserDepartmentModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null as any);
  const today = new Date();
  const [listId, setListId] = useState<any>(getListIdByStatusValue("", openLinkDocumentModal));
  const [data, setData] = useState<any>([]);
  const [peopleDocument, setPeopleDocument] = useState<any>([]);
  const [peopleDetail, setPeopleDetail] = useState<any>([]);
  const [totalUser2, setTotalUser2] = useState(0);
  const [selectedDocumentDepartment, setSelectedDocumentDepartment] = useState<any>([]);
  const [totalUser, setTotalUser] = useState(0);
  const [departmentData, setDepartmentData] = useState<any>([]);
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const documentDetailUrl = getEnv("REACT_APP_DOCUMENT_DETAILS_URL");
  const { searchParams, replaceSearchParams } = useSearchParams();
  const { email, name } = useUser();

  const isDepartmentMode = useMemo(() => searchParams.get("mode") === "department", [searchParams]);

  const groupEmails = useMemo(() => {
    return (
      peopleDocument
        ?.filter((s: any) => s.email && s.jobTitle === "TKDC" && s.name !== "QLTL_GrTest")
        .map((s: any) => s.email) || []
    );
  }, [peopleDocument]);

  const { data: nonEmailUsers = [] } = useNonEmailUsers(groupEmails);

  const onPicked = (e: any) => {
    setSelectedDocument(e);
  };

  const toggleLinkDocumentDepartmentModal = () => {
    setOpenLinkDocumentModalModal(!openLinkDocumentModal);
    setListId(getListIdByStatusValue("", !openLinkDocumentModal));
    searchParams.set("mode", "department");
    replaceSearchParams(searchParams);
  };

  const toggleLinkDocumentModal = () => {
    setOpenLinkDocumentModalModal(!openLinkDocumentModal);
    setListId(getListIdByStatusValue("", !openLinkDocumentModal));
    setDepartmentData([]);
    searchParams.delete("mode");
    replaceSearchParams(searchParams);
  };

  const onCloseModal = useCallback(() => {
    setOpenLinkDocumentModalModal(!openLinkDocumentModal);
    setListId(getListIdByStatusValue("", !openLinkDocumentModal));
  }, [openLinkDocumentModal]);

  const removeElements = (arr: any) => {
    return Array.from(new Set(arr.map((obj: any) => obj.email))).map((email) =>
      arr.find((obj: any) => obj.email === email),
    );
  };

  const getDocumentInfo = useCallback(async () => {
    if (!selectedDocument) return;
    if (selectedDocument) {
      if (selectedDocument.docPublicEndUsers) {
        setDocument(selectedDocument);
        if (isDepartmentMode) {
          setSelectedDocumentDepartment(selectedDocument);
        }
      } else
        DocumentService.getPublicDocumentInfoFromWorkingDocument(selectedDocument.docWorkingId)
          .then((res) => {
            setDocument(res);
          })
          .catch((error) => {
            console.log(error);
          });
    } else {
      const documentInfoPromises: any[] = [];
      selectedDocument?.forEach((e: any) => {
        if (e.docPublicEndUsers) setSelectedDocumentDepartment(selectedDocument);
        else {
          documentInfoPromises.push(DocumentService.getPublicDocumentInfoFromWorkingDocument(e.docWorkingId));
        }
      });
      await Promise.all(documentInfoPromises)
        .then((result: any[]) => {
          setSelectedDocumentDepartment(result);
        })
        .catch((error: any) => console.log(error));
    }
  }, [isDepartmentMode, selectedDocument]);

  const isReadUser = (arr: [], userMail: any): boolean => {
    return arr.findIndex((e: any) => e.email.toLowerCase() === userMail.toLowerCase()) > -1;
  };

  const getData = useCallback(() => {
    const readPeople = document?.docReaders?.length > 0 ? document.docReaders?.length : 0;
    return [
      {
        ID: 1,
        title: "Số người được triển khai",
        soluong: totalUser,
        percent: "1",
      },
      {
        ID: 2,
        title: "Số người đã đọc CV,CS/Đã làm bài kiểm tra",
        soluong: readPeople,
        percent: readPeople / totalUser,
      },
      {
        ID: 3,
        title: "Số người chưa đọc CV,CS/Chưa làm bài kiểm tra",
        soluong: totalUser - readPeople,
        percent: (totalUser - readPeople) / totalUser,
      },
    ];
  }, [document?.docReaders?.length, totalUser]);

  const handleRenderRead = (e: any) => {
    return <p>{e.data.read ? "✔" : ""}</p>;
  };

  const handleRenderNotRead = (e: any) => {
    return <p>{e.data.notRead ? "X" : ""}</p>;
  };

  const onExporting = (e: any) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("DanhSachPhanPhoi");

    const customizeCell = (options: any) => {
      const { gridCell, excelCell } = options;

      // Customize only boolean values
      if (gridCell.rowType === "data" && typeof gridCell.value === "boolean") {
        if (gridCell.data.notRead) excelCell.value = gridCell.value ? "X" : "";
        else excelCell.value = gridCell.value ? "✔" : "";
      }
    };

    exportDataGrid({
      component: e.component,
      worksheet,
      topLeftCell: { row: 4, column: 1 },
      customizeCell,
    }).then((cellRange) => {
      // header
      const headerRow = worksheet.getRow(2);
      headerRow.height = 30;
      worksheet.mergeCells(2, 1, 2, 8);

      headerRow.getCell(1).value = "DANH SÁCH PHÂN PHỐI";
      headerRow.getCell(1).font = { name: "Segoe UI Light", size: 22 };
      headerRow.getCell(1).alignment = { horizontal: "center" };

      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          `DanhSachPhanPhoi_${selectedDocument.Title}.xlsx`,
        );
      });
    });
  };

  const handleCloseUserDepartmentModal = () => {
    searchParams.delete("empCode");
    searchParams.delete("deptCode");
    searchParams.delete("isDepartment");
    replaceSearchParams(searchParams);
    setOpenUserDepartmentModal(false);
  };

  const sendMail = async (approver: any) => {
    if (document) {
      const tomail = approver?.email;
      const template = mailtemplates.find((m: any) => m.eMailType === "RTRTD");
      const url = `${documentDetailUrl}/${document.docWorkingId}?fileId=${document?.fileId}&status=publish&status=publish&action=info&index=2`;
      const content = template.eContent
        .replace(mailRegexs.zero + ";", document.Title)
        .replace(mailRegexs.one + ";", document?.docPublishViewVersion?.toString())
        .replace(mailRegexs.two + ";", document?.docEditionVersion?.toString())
        .replace(mailRegexs.three + ";", moment(document?.effectiveFrom).format(DateFormat.DD_MM_YYYY))
        .replace(mailRegexs.four + ";", name)
        .replace(mailRegexs.five + ";", email)
        .replace(mailRegexs.siteUrl, url);
      const subject = template.eSubject;

      MailService.sendMailByBotit({ content, subject, toMail: tomail });
    } else {
      CreateNotification({
        title: "Thông báo",
        body: "Không tìm thấy thông tin tài liệu cần nhắc nhở. Vui lòng thử lại sau",
        icon: "/icons/warning.png",
      });
    }
  };

  const handleRemind = () => {
    const usersNotRead = peopleDetail?.filter((e: any) => e.notRead && e.email);
    usersNotRead.forEach((e: any) => sendMail(e));
    CreateNotification({
      title: "Thông báo",
      body: "Anh/Chị vừa gửi email nhắc nhở các user chưa đọc tài liệu",
      icon: "/icons/success.png",
    });
  };

  useEffect(() => {
    getDocumentInfo();
  }, [getDocumentInfo]);

  useEffect(() => {
    if (!document) return;
    const endUsers = document.fileAssignedTo ? JSON.parse(document.fileAssignedTo) : [];
    setPeopleDocument(removeElements(endUsers));
  }, [document]);

  useEffect(() => {
    // Ensure we have the necessary data before proceeding
    if (!document || !selectedDocument) {
      // Optionally reset related states if document/selectedDocument become null
      // if (!document && peopleDetail.length > 0) setPeopleDetail([]);
      // if (!selectedDocument && data.length > 0) setData([]);
      // if (!document && totalUser > 0) setTotalUser(0);
      return;
    }

    const readPeople = document?.docReaders || [];

    const personalUser =
      peopleDocument?.filter(
        (item: any) => item.email && !item.email.toLowerCase().startsWith("qltl_gr") && item.jobTitle !== "TKDC",
      ) || [];

    const sharedUser = readPeople.filter((item: any) => item.email);

    // Combine users, handling potential duplicates and non-email users
    const readUsers = [
      ...sharedUser.filter(
        (user: { email: string }) =>
          !personalUser.some(
            (readUser: { email: string }) => readUser.email.toLowerCase() === user.email.toLowerCase(),
          ),
      ),
      ...personalUser,
      ...(nonEmailUsers.filter(
        (s) => !sharedUser.some((reader: any) => reader.id?.toLowerCase() === s.employeeCode?.toLowerCase()),
      ) || []),
    ];

    // Create the detailed array for the grid/display
    const arr = readUsers.map((e: any, index: number) => ({
      STT: index + 1,
      personId: isGUID(e.Id) ? "" : e.Id || e.id,
      name: e.displayName || e.name,
      email: e.email,
      department: `${StringHelper.dashSplit(e.departmentCode)[0]}`,
      pDeptCode: `${(e.departmentCode || e.unit)} ${isCBP(e.jobTitle) ? "-CBP" : ""}`,
      read: isReadUser(readPeople, e.email),
      notRead: !isReadUser(readPeople, e.email),
    }));

    // Calculate stats data
    const calculatedStatsData = [
      {
        ID: 1,
        title: "Số người được triển khai",
        soluong: arr.length,
        percent: "1", // Keep as string "1" as per original
      },
      {
        ID: 2,
        title: "Số người đã đọc CV,CS/Đã làm bài kiểm tra",
        soluong: readPeople.length,
        percent: arr.length ? readPeople.length / arr.length : 0,
      },
      {
        ID: 3,
        title: "Số người chưa đọc CV,CS/Chưa làm bài kiểm tra",
        soluong: arr.length - readPeople.length,
        percent: arr.length ? (arr.length - readPeople.length) / arr.length : 0,
      },
    ];

    // --- Apply conditional updates to prevent unnecessary re-renders ---

    // Update peopleDetail only if the content has semantically changed
    setPeopleDetail((prevArr: any) => {
      // Check length first - cheap comparison
      if (prevArr.length !== arr.length) {
        // console.log("PeopleDetail length changed, updating");
        return arr; // Length changed, definitely update
      }
      // Perform a shallow comparison of key properties for each item
      const isSameContent = prevArr.every((item: any, index: number) => {
        const newItem = arr[index];
        // Compare properties that are likely to change or are crucial identifiers
        return (
          item.email === newItem.email &&
          item.read === newItem.read &&
          item.notRead === newItem.notRead &&
          item.name === newItem.name
        ); // Include name/other relevant fields if they can change
      });
      if (isSameContent) {
        // console.log("PeopleDetail content same, skipping update");
        return prevArr; // Content hasn't changed, prevent update
      }
      // console.log("PeopleDetail content changed, updating");
      return arr; // Content changed, update
    });

    // Update stats data only if the content has semantically changed
    setData((prevData: any[]) => {
      if (prevData.length !== calculatedStatsData.length) {
        // console.log("StatsData length changed, updating");
        return calculatedStatsData;
      }
      const isSameContent = prevData.every((item, index) => {
        const newItem = calculatedStatsData[index];
        // Compare properties - soluong and percent are the dynamic ones
        // Use loose equality or add tolerance for floats if needed, but strict is safer first
        return item.ID === newItem.ID && item.soluong === newItem.soluong && item.percent === newItem.percent; // Direct comparison for numbers/strings
      });
      if (isSameContent) {
        // console.log("StatsData content same, skipping update");
        return prevData;
      }
      // console.log("StatsData content changed, updating");
      return calculatedStatsData;
    });

    // Update total user counts only if the value has changed
    setTotalUser((prev) => {
      if (prev === arr.length) {
        // console.log("TotalUser same, skipping update");
        return prev;
      }
      // console.log("TotalUser changed, updating");
      return arr.length;
    });
    setTotalUser2((prev) => {
      // Assuming totalUser2 is intended to mirror totalUser based on arr.length
      if (prev === arr.length) {
        // console.log("TotalUser2 same, skipping update");
        return prev;
      }
      // console.log("TotalUser2 changed, updating");
      return arr.length;
    });
  }, [document, nonEmailUsers, peopleDocument, selectedDocument]); // Dependencies remain the same
  useEffect(() => {
    const departmentSet = new Set<string>();

    const fileAssignedTo = selectedDocumentDepartment.fileAssignedTo ? JSON.parse(selectedDocument.fileAssignedTo) : [];

    fileAssignedTo.forEach((user: any) => {
      if (user?.department) {
        let departmentCode: string = user.departmentCode;
        if (isCBP(user.jobTitle)) {
          departmentCode = departmentCode + "-CBP";
        }

        departmentSet.add(departmentCode);
      }
    });

    const departmentList = Array.from(departmentSet).map((departmentName) => ({
      departmentName,
    }));

    setDepartmentData(departmentList);
  }, [selectedDocument?.fileAssignedTo, selectedDocumentDepartment]);

  return (
    <>
      <Col sm={12} md={12} className="py-3">
        <Col className="py-3 statistic-header">
          <h3>DANH SÁCH TRIỂN KHAI TÀI LIỆU</h3>
          <p>
            <i>Thống kê danh sách phân phối tài liệu (chi tiết theo đơn vị, cá nhân, group cần triển khai)</i>
          </p>
        </Col>
        <Box title="Tài liệu được triển khai gần đây">
          <RecentDistributionDocument setSelectedDocument={setSelectedDocument} />
        </Box>
        <Box
          title="Danh sách đơn vị/cá nhân nhận tài liệu."
          className="box-statistic"
          titleRight={
            <div className="px-4 py-2 d-flex align-items-center">
              {/* <Button
                title={"In tài liệu"}
                className="btn mr-2"
                variant="outline-info"
              >
                <FontFa name="faPrint" size={"xs"} />
              </Button> */}
              {selectedDocument && (
                <Button
                  title={"Nhắc nhở user đọc tài liệu"}
                  className="mr-2"
                  variant="outline-danger"
                  onClick={() => handleRemind()}
                >
                  <FontFa name="faEnvelope" size={"xs"} />
                </Button>
              )}
            </div>
          }
        >
          <div className="pt-1 d-flex">
            <h6 className="pt-2">Chọn tài liệu để thống kê:</h6>
            <div className="px-4 d-flex align-items-center">
              <Button
                title="Thống kê phân phối theo người dùng"
                className="btn mr-2"
                variant="outline-info"
                onClick={toggleLinkDocumentModal}
              >
                <FontFa name="faUser" size={"xs"} />
              </Button>
              <Button
                title="Thống kê phân phối theo phòng ban"
                className="btn mr-2"
                variant="outline-primary"
                onClick={toggleLinkDocumentDepartmentModal}
              >
                <FontFa name="faUsers" size={"xs"} />
              </Button>
            </div>
          </div>
          {selectedDocument && peopleDetail && (
            <>
              <Row>
                <Col sm={4} md={4}>
                  <div className="pt-1 px-4">
                    <p>
                      - Tên tài liệu/CV/CS: <b>{selectedDocument.Title}</b>
                    </p>
                    <p>- Lần sửa đổi: {selectedDocument.docEditionVersion}</p>
                    <p>- Lần ban hành: {selectedDocument.docPublishViewVersion}</p>
                    <p>
                      - Thời gian chiết xuất dữ liệu:{" "}
                      {today.toLocaleDateString() + " - " + today.getHours() + ":" + today.getMinutes()}
                    </p>
                    <p>- Tổng số nhân viên được triển khai (SL user nhận được triển khai CV): {totalUser2}</p>
                  </div>
                </Col>
                {!isDepartmentMode && (
                  <Col sm={8} md={8}>
                    <div className="d-flex column p-0">
                      <div>
                        <DataGrid
                          noDataText="Không tìm thấy tài liệu"
                          id="grid_content"
                          dataSource={data}
                          showBorders={true}
                          showRowLines={true}
                          height={300}
                          wordWrapEnabled={true}
                        >
                          <Column caption="" dataField="title" dataType="string" width={200} />
                          <Column
                            alignment="center"
                            caption="Số lượng"
                            dataField="soluong"
                            dataType="number"
                            width={100}
                          />
                          <Column
                            alignment="center"
                            caption="Tỷ lệ"
                            dataField="percent"
                            dataType="number"
                            width={100}
                            format="percent"
                          />
                        </DataGrid>
                      </div>
                      <div>{document && data && <StatisticChart data={data} />}</div>
                    </div>
                  </Col>
                )}
              </Row>
              <div>
                {!isDepartmentMode ? (
                  <DataGrid
                    id="grid_content"
                    className="grid_content"
                    noDataText="Không tìm thấy thông tin tài liệu"
                    dataSource={peopleDetail}
                    showBorders={true}
                    showRowLines={true}
                    wordWrapEnabled={true}
                    remoteOperations={true}
                    onExporting={onExporting}
                    allowColumnReordering={false}
                  >
                    <Export enabled={true} />
                    <Scrolling mode="standard" />
                    <ColumnFixing enabled={true} />
                    <FilterRow visible={true} applyFilter={true} />
                    <HeaderFilter visible={true} />

                    <Column
                      caption="STT"
                      alignment="center"
                      dataField="STT"
                      dataType="number"
                      width={70}
                      allowSorting={false}
                      allowHeaderFiltering={false}
                    />
                    <Column
                      alignment="center"
                      caption="Mã nhân viên"
                      dataField="personId"
                      dataType="string"
                      width={150}
                      allowSorting={false}
                    />
                    <Column caption="Họ và tên" dataField="name" dataType="string" allowSorting={false} />
                    <Column caption="Cơ quan/Chi nhánh" dataField="department" dataType="string" allowSorting={false} />
                    <Column caption="Đơn vị" dataField="pDeptCode" dataType="string" allowSorting={false} />
                    <Column
                      alignment="center"
                      caption="Đã đọc tài liệu/văn bản"
                      dataField="read"
                      cellRender={handleRenderRead}
                      dataType="string"
                      width={150}
                      allowSorting={false}
                      allowFiltering={false}
                    />
                    <Column
                      alignment="center"
                      caption="Chưa đọc tài liệu/văn bản"
                      dataField="notRead"
                      dataType="string"
                      cellRender={handleRenderNotRead}
                      width={150}
                      allowSorting={false}
                      allowFiltering={false}
                    />
                    <Column caption="Ghi chú" dataField="GHICHUTHOIGIAN" dataType="string" width={160} />
                  </DataGrid>
                ) : (
                  <DataGrid
                    id="grid_content"
                    noDataText="Không tìm thấy tài liệu"
                    dataSource={departmentData}
                    showBorders={true}
                    showRowLines={true}
                    wordWrapEnabled={true}
                    remoteOperations={true}
                  >
                    <Column
                      caption="STT"
                      dataField="index"
                      alignment="center"
                      allowEditing={false}
                      width={100}
                      cellRender={(data) => data.rowIndex + 1}
                      headerFilter={{
                        allowSearch: false,
                      }}
                    />
                    <Column dataField="departmentName" dataType="string" caption="Đơn vị được triển khai" />
                    <Export enabled={true} fileName={`Danhsachphanphoi_${selectedDocument.Title}`} />
                  </DataGrid>
                )}
              </div>
            </>
          )}
        </Box>

        <Box
          title="Danh sách tài liệu được triển khai."
          titleRight={<div className="px-4 py-2 d-flex align-items-center"></div>}
        >
          <div className="pt-1 d-flex">
            <h6 className="pt-2">Chọn nhân viên/cơ quan đơn vị</h6>
            <div className="px-4 d-flex align-items-center">
              <Button
                title="Thống kê phân phối theo người dùng"
                className="btn mr-2"
                variant="outline-info"
                onClick={() => setOpenUserDepartmentModal(true)}
              >
                <FontFa name="faUser" size={"xs"} />
              </Button>
            </div>
          </div>
        </Box>
      </Col>

      <LinkDocumentModal
        onClose={onCloseModal}
        isOpen={openLinkDocumentModal}
        isUrl={false}
        onPicked={onPicked}
        listId={listId}
      />

      <UserDepartmentModal isOpen={openUserDepartmentModal} onClose={() => handleCloseUserDepartmentModal()} />
    </>
  );
});
